import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/core/components/ui/badge";
import { ROLE_TO_LABEL, USER_ROLES } from "@/user/constants";
import { DetailedUser } from "@/user/user.d";

// Map roles to badge color variants
const ROLE_TO_BADGE_VARIANT: Record<
  string,
  | "purple"
  | "blue"
  | "green"
  | "orange"
  | "aqua"
  | "gray"
  | "magenta"
  | "gold"
  | "red"
> = {
  [USER_ROLES.ADMIN]: "purple",
  [USER_ROLES.OWNER]: "blue",
  [USER_ROLES.MANAGER]: "green",
  [USER_ROLES.REP]: "orange",
  [USER_ROLES.TECH]: "aqua",
};

export const RoleCol = (): ColumnDef<DetailedUser> => ({
  header: "Role",
  accessorFn: (row) => ROLE_TO_LABEL[row.role as keyof typeof ROLE_TO_LABEL],
  cell: ({ row }) => {
    const role = row.original.role;
    const label = ROLE_TO_LABEL[role as keyof typeof ROLE_TO_LABEL];
    const variant = ROLE_TO_BADGE_VARIANT[role] || "gray";

    return <Badge variant={variant}>{label}</Badge>;
  },
  size: 100,
});
